import { useState } from "react";
import PhotoModal from "../../progress-photos/PhotoModal";
import SvgIcon from "../../../../../parts/SvgIcon";

const ProgressPhotosContainer = ({
  bodyPhotos,
  date,
  athlete,
  organizationCoachParam,
}) => {
  const [modal, setModal] = useState({
    open: false,
    type: "",
    pictureImg: "",
  });
  const toggleModal = (pictureImg = "", type = "") => {
    setModal({
      open: modal.open ? false : true,
      type,
      pictureImg,
    });
  };

  return (
    <section role="progress-photos-wrapper">
      <div>
        {Object.keys(bodyPhotos).map((key) => (
          <img
            src={bodyPhotos[key]}
            className="composition-photo"
            onClick={() => {
              toggleModal(bodyPhotos[key], key);
            }}
          />
        ))}
      </div>
      <footer>
        <span>
          <a
            href={`/athlete-portal/metrics/progress-photos?date=${date}&athlete=${athlete}&bodycomp=true${organizationCoachParam}`}
          >
            <b>See More Photos</b>
          </a>
          <SvgIcon src="/img/new-icons/arrow-square-right-gradient.svg" />
        </span>
      </footer>
      {modal.open ? (
        <PhotoModal photo={modal} toggleModal={toggleModal} />
      ) : null}
    </section>
  );
};

export default ProgressPhotosContainer;
